import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "63",
  viewBox: "0 0 40 63"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0.587224424,8.20012202 C0.565621799,8.17951663 0.544508978,8.15840377 0.523903633,8.1368011 C-0.198653247,7.37927158 -0.170303563,6.17942329 0.587224424,5.45686495 L5.75892855,0.523901379 C6.49127071,-0.174633793 7.64319631,-0.174633793 8.37553847,0.523901379 L39.4127756,30.1283715 C39.4343782,30.1489769 39.455491,30.1700897 39.4760964,30.1916924 C40.1986532,30.9492219 40.1703036,32.1490702 39.4127756,32.8716285 L8.37553847,62.4760986 C7.64319631,63.1746338 6.49127071,63.1746338 5.75892855,62.4760986 L0.587224424,57.5431351 C0.565621799,57.5225297 0.544508978,57.5014168 0.523903633,57.4798141 C-0.198653247,56.7222846 -0.170303563,55.5224363 0.587224424,54.799878 L25.0147462,31.5 L0.587224424,8.20012202 Z"
    }, null, -1)
  ])))
}
export default { render: render }